import { getData } from "./base.service";

export function getGeoJsonByName(name: string) {
    const data: Promise<any> = getData(`/geodata/${name}`);
    return data;
}

export function getSettlementById(fid: number) {
    const data: Promise<any> = getData(`/settlements/${fid}`);
    return data;
}

export function getKmlByName(name: string) {
    const data: Promise<any> = getData(`/geodata/${name}/kml`);
    return data;
}